import {
  Box,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  useTheme,
  Fade,
  InputAdornment,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import FilterKilscheTypeAndThicknes from "./FilterKilscheTypeAndThicknes";
import YearsDrop from "../components/YearsDrop";
import MonthSelector from "../components/Month";
import TotalChart from "../TotalChart";
import { useGetEnumsValue } from "../../../OrganizationDefinitions/CreateUserAccount/Hooks";
import { enumsRender } from "../../../OrganizationDefinitions/CreateUserAccount/StaticFiles";

import {
  useGetAvrageKlischeArea,
  useGetAvrageKlischePrice,
  useGetKlischePrice,
} from "../../../Production/OrderArchive/Hook";
import ChartRenderer from "./ChartRenderer";
import Tabs from "./Tabs";
import moment from "moment-jalaali";
import useCheckDisplayChart from "../components/useCheckDisplayChart";
``;
import TitleChart from "../components/TitleChart";
import { Autocomplete, TextField, Paper, Grid } from "@mui/material";
import { useGetProformaInvoiceSearchDTO } from "../../../Reports/Components/Components/PreInvoicesCharts/Hooks/index";
import { FilterIcon } from "lucide-react";
import FilterHandler from "../components/FilterHandler";
import { Clear } from "@mui/icons-material";

function SellingPriceChart() {
  const toPersianDigits = (input) => {
    if (input === null || input === undefined) return "";

    const str = input.toString();

    // normalize Persian digits to English
    const normalized = str.replace(
      /[۰-۹]/g,
      (d) => "0123456789"["۰۱۲۳۴۵۶۷۸۹".indexOf(d)],
    );

    // find number only
    const match = normalized.match(/\d+(?:,\d{3})*(?:\.\d+)?/);
    if (!match) return str;

    const formatted = Number(match[0].replace(/,/g, "")).toLocaleString(
      "en-US",
    );

    const persianFormatted = formatted.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);

    // replace ONLY the matched number
    return str.replace(match[0], persianFormatted);
  };
  const theme = useTheme().palette.mode;

  const currentJalaliYear = moment().locale("en").format("jYYYY");
  const [year, setYear] = useState({ year: currentJalaliYear });
  const [month, setMonth] = useState(0);
  const [customerSelectOpen, setCustomerSelectOpen] = useState(false);
  const [designerSelectOpen, setDesignerSelectOpen] = useState(false);
  const [designer, setDesigner] = useState({
    value: "00000000-0000-0000-0000-000000000000",
    key: "همه",
  });
  const [customer, setCustomer] = useState({
    value: "00000000-0000-0000-0000-000000000000",
    key: "همه",
  });
  const { data: selectOptionsData } = useGetProformaInvoiceSearchDTO();
  const [chartFilter, setChartFilter] = useState({ name: "mondth", enum: 1 });
  const [mount, setMount] = useState({});
  const [totalInfo, setTotalInfo] = useState({});
  const [totalItems, setTotalItems] = useState([]);
  const { data: enumsData } = useGetEnumsValue(["InvoiceType"]);
  const [invoiceTypeSelected, setinvoiceTypeSelected] = useState(null);

  const [KilscheThicknes, setKilscheThicknes] = useState(
    "00000000-0000-0000-0000-000000000000",
  );
  const [activeFilterType, setActiveFilterType] = useState(1);
  const [KlischeType, setKlischeType] = useState({
    KlischeType: "00000000-0000-0000-0000-000000000000",
  });

  //* fetch data apis
  const { mutate, data } = useGetAvrageKlischePrice();

  const { mutate: mutateArea, data: area } = useGetAvrageKlischeArea();
  const { mutate: mutatePrice, data: price } = useGetKlischePrice();

  useEffect(() => {
    let source = null;

    switch (activeFilterType) {
      case 1:
        source = price;
        break;
      case 2:
        source = area;
        break;
      default:
        source = data;
        break;
    }
    if (!source) return;
    const totalRecords = source?.data?.data?.total || 0;
    setTotalInfo({
      tabIndex: activeFilterType,
      total: activeFilterType === 3 ? "" : totalRecords,
    });
  }, [activeFilterType, data, price, area]);

  const tabHandler = (type) => {
    setChartFilter(() =>
      type === "day"
        ? { name: "day", enum: 0 }
        : type === "mondth"
          ? { name: "mondth", enum: 1 }
          : { name: "year", enum: 2 },
    );
  };

  useEffect(() => {
    if (KlischeType || KilscheThicknes)
      if (activeFilterType === 1) {
        mutatePrice({
          klischeTypeId: KlischeType.KlischeType
            ? KlischeType.KlischeType
            : "00000000-0000-0000-0000-000000000000",
          klischeThicknessId: KilscheThicknes.KilscheThicknes
            ? KilscheThicknes.KilscheThicknes
            : "00000000-0000-0000-0000-000000000000",
          chartReportTiming: chartFilter.enum,
          year: chartFilter.enum === 1 ? year.year : 0,
          customerId: customer?.value
            ? customer?.value
            : "00000000-0000-0000-0000-000000000000",
          designerId: designer?.value
            ? designer?.value
            : "00000000-0000-0000-0000-000000000000",
          invoiceType: invoiceTypeSelected,
        });
      } else if (activeFilterType === 2) {
        mutateArea({
          klischeTypeId: KlischeType.KlischeType
            ? KlischeType.KlischeType
            : "00000000-0000-0000-0000-000000000000",
          klischeThicknessId: KilscheThicknes.KilscheThicknes
            ? KilscheThicknes.KilscheThicknes
            : "00000000-0000-0000-0000-000000000000",
          chartReportTiming: chartFilter.enum,
          year: chartFilter.enum === 1 ? year.year : 0,
          customerId: customer?.value
            ? customer?.value
            : "00000000-0000-0000-0000-000000000000",
          designerId: designer?.value
            ? designer?.value
            : "00000000-0000-0000-0000-000000000000",
          invoiceType: invoiceTypeSelected,
        });
      } else if (activeFilterType === 3) {
        mutate({
          klischeTypeId: KlischeType.KlischeType
            ? KlischeType.KlischeType
            : "00000000-0000-0000-0000-000000000000",
          klischeThicknessId: KilscheThicknes.KilscheThicknes
            ? KilscheThicknes.KilscheThicknes
            : "00000000-0000-0000-0000-000000000000",
          chartReportTiming: chartFilter.enum,
          year: chartFilter.enum === 1 ? year.year : year.year,
          month: month.month,
          customerId: customer?.value
            ? customer?.value
            : "00000000-0000-0000-0000-000000000000",
          designerId: designer?.value
            ? designer?.value
            : "00000000-0000-0000-0000-000000000000",
          mount: mount?.month,
          year: year?.year,
          invoiceType: invoiceTypeSelected,
        });
      }
    return () => {};
  }, [
    chartFilter,
    KilscheThicknes,
    activeFilterType,
    KlischeType,
    year,
    customer,
    designer,
    year,
    mount,
    invoiceTypeSelected,
  ]);
  /* -------------------------------- Accrdion -------------------------------- */
  const chartKey = "priceChart";
  const { displayChart } = useCheckDisplayChart(chartKey);
  const [filter, setFilter] = useState(false);

  return (
    <>
      {displayChart ? (
        <>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 2,
              marginBottom: "4px",
              flexWrap: "nowrap",
              overflowX: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "100%",
                padding: "0.5rem",
              }}
            >
              <Tabs
                activeFilterType={activeFilterType}
                setActiveFilterType={setActiveFilterType}
              />
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                width: "60%",
                display: "flex",
                justifyContent: "flex-start",
                minWidth: 200,
              }}
            >
              <TitleChart label={"فاکتورها"} chartKey={chartKey} />
            </Box>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginLeft: "auto",
                  marginRight: "8px",
                }}
              >
                <Button
                  onClick={() => tabHandler("day")}
                  sx={{
                    width: "2rem",
                    background:
                      chartFilter.name === "day" ? "rgba(30, 106, 253, 1)" : "",
                    color:
                      chartFilter.name === "day"
                        ? "#fff"
                        : "rgba(30, 106, 253, 1)",
                    borderRadius: "8px 0px 0px 8px",
                    border: "1px solid rgba(30, 106, 253, 1)",
                  }}
                >
                  روز
                </Button>

                <Button
                  onClick={() => tabHandler("mondth")}
                  sx={{
                    width: "2rem",
                    background:
                      chartFilter.name === "mondth"
                        ? "rgba(30, 106, 253, 1)"
                        : "",
                    color:
                      chartFilter.name === "mondth"
                        ? "#fff"
                        : "rgba(30, 106, 253, 1)",
                    borderRadius: "0px 0px 0px 0px",
                    border: "1px solid rgba(30, 106, 253, 1)",
                  }}
                >
                  ماه
                </Button>
                <Button
                  onClick={() => tabHandler("year")}
                  sx={{
                    width: "2rem",
                    background:
                      chartFilter.name === "year"
                        ? "rgba(30, 106, 253, 1)"
                        : "",
                    color:
                      chartFilter.name === "year"
                        ? "#fff"
                        : "rgba(30, 106, 253, 1)",
                    borderRadius: "0 8px 8px 0px",
                    border: "1px solid rgba(30, 106, 253, 1)",
                  }}
                >
                  سال
                </Button>
              </Box>
              <FilterHandler filter={filter} setFilter={setFilter} />
            </Box>
          </Box>
          {filter && (
            <Fade in={filter} timeout={300}>
              <Grid
                container
                sx={{
                  my: 1,
                  backgroundColor: theme == "light" ? "#E6F1FF" : "#161B25",
                }}
              >
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      p: 0,
                      width: "100%",
                      padding: "8px",
                    }}
                  >
                    {chartFilter.name === "day" && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          columnGap: 1,
                          mx: 0.5,
                        }}
                      ></Box>
                    )}
                    <FilterKilscheTypeAndThicknes
                      KlischeType={KlischeType}
                      setKlischeType={setKlischeType}
                      KilscheThicknes={KilscheThicknes}
                      setKilscheThicknes={setKilscheThicknes}
                      chartFilter={chartFilter}
                      year={year}
                      setYear={setYear}
                      month={month}
                      setMonth={setMonth}
                    />

                    <Box
                      sx={{
                        width: "400px",
                        display: "flex",
                        alignItems: "start",
                        columnGap: 1,
                        px: 0.5,
                      }}
                    >
                      <Box display={"flex"} sx={{ width: "200px", p: 0 }}>
                        <Autocomplete
                          PaperComponent={({ children }) => (
                            <Paper style={{ fontSize: "12px", p: 0 }}>
                              {children}
                            </Paper>
                          )}
                          size="small"
                          fullWidth
                          id="asynchronous-demo"
                          sx={{ fontSize: "10px !important" }}
                          open={designerSelectOpen}
                          value={designer}
                          onOpen={() => {
                            setDesignerSelectOpen(true);
                          }}
                          onClose={() => {
                            setDesignerSelectOpen(false);
                          }}
                          onChange={(e, v) => {
                            setDesigner(v);
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option.key === value.key
                          }
                          getOptionLabel={(option) => option.key}
                          options={selectOptionsData?.designers ?? []}
                          loading={false}
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              size="small"
                              {...params}
                              label="طراح"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {false ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                      </Box>
                      <Box display={"flex"} sx={{ width: "200px", p: 0 }}>
                        <Autocomplete
                          PaperComponent={({ children }) => (
                            <Paper style={{ fontSize: "12px" }}>
                              {children}
                            </Paper>
                          )}
                          size="small"
                          fullWidth
                          id="asynchronous-demo"
                          sx={{ fontSize: "10px !important" }}
                          open={customerSelectOpen}
                          value={customer}
                          onOpen={() => {
                            setCustomerSelectOpen(true);
                          }}
                          onClose={() => {
                            setCustomerSelectOpen(false);
                          }}
                          onChange={(e, v) => {
                            setCustomer(v);
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option.key === value.key
                          }
                          getOptionLabel={(option) => option.key}
                          options={selectOptionsData?.customers ?? []}
                          loading={false}
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              size="small"
                              {...params}
                              label=" مشتری"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {false ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                      </Box>
                    </Box>
                  </Box>
                  <Grid item xs={12} sm={2}>
                    <FormControl
                      fullWidth
                      sx={{
                        px: "4px",
                        py: "12px",
                        backgroundColor:
                          theme == "light" ? "#E6F1FF" : "#161B25",
                      }}
                    >
                      <InputLabel id="demo-simple-select-label">
                        نوع فاکتور
                      </InputLabel>
                      <Select
                        size="small"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={invoiceTypeSelected || ""}
                        name="users"
                        onChange={(event) => {
                          setinvoiceTypeSelected(event.target.value);
                        }}
                        displayEmpty
                        endAdornment={
                          invoiceTypeSelected ? (
                            <InputAdornment position="end">
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setinvoiceTypeSelected("");
                                }}
                                edge="end"
                                color="error"
                              >
                                <Clear fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          ) : null
                        }
                        sx={{
                          "& .MuiSelect-select": {
                            paddingRight: "32px",
                          },
                        }}
                      >
                        {enumsRender(enumsData, "InvoiceType").map(
                          (item, i) => (
                            <MenuItem
                              key={i}
                              sx={{ fontSize: "0.8rem" }}
                              value={item.value}
                            >
                              {item.key}
                            </MenuItem>
                          ),
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Fade>
          )}
          <Box>
            {(KlischeType || KilscheThicknes) && (
              <ChartRenderer
  data={
    activeFilterType === 1
      ? price?.data?.data.items
      : activeFilterType === 2
        ? area?.data?.data.items
        : data?.data?.data.items
  }
  title={
    activeFilterType === 1
      ? "قیمت کل فروش"
      : activeFilterType === 2
        ? "مساحت فروش"
        : "میانگین قیمت فروش"
  }
  useSeparator={activeFilterType === 1 || activeFilterType === 3} // قیمت کل و میانگین قیمت دارای seperator
/>

            )}
          </Box>
          {(KlischeType || KilscheThicknes) && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
                px: 1,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <Box sx={{ color: "#3592FB", display: "flex", columnGap: 1 }}>
                  <Typography sx={{ fontSize: "0.9rem" }}>
                    {totalInfo?.tabIndex === 1
                      ? " قیمت کل  فروش :"
                      : totalInfo?.tabIndex === 2
                        ? " مساحت :"
                        : totalInfo?.tabIndex === 3
                          ? " "
                          : ""}
                  </Typography>
                  <Typography>
                    {toPersianDigits(totalInfo?.total ?? "")}
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}
        </>
      ): <Box
              sx={{
                flexGrow: 1,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                minWidth: 200,
              }}
            >
              <TitleChart label={"فاکتورها"} chartKey={chartKey} />
            </Box>}
    </>
  );
}

export default SellingPriceChart;
